// extracted by mini-css-extract-plugin
export default {"col":"Footer_col__y3H2O","links":"Footer_links__2VAlO","link":"Footer_link__sgKeT","wrap":"Footer_wrap__Ih60X","wrap_1":"Footer_wrap_1__GzzgI"};